import { ChevronIcon } from '@/components';

interface CollapsibleHeaderProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
}

export const CollapsibleHeader = ({
  title,
  isOpen,
  onToggle,
}: CollapsibleHeaderProps) => {
  return (
    <button
      onClick={onToggle}
      className="flex items-center justify-between w-full lg:py-3 lg:pb-5 text-left lg:border-b border-gray-200"
    >
      <span className="font-medium text-lg text-grey-dark">{title}</span>

      <ChevronIcon classes="ml-2" direction={isOpen ? 'up' : 'down'} />
    </button>
  );
};
